import { useUserData } from "@me8eon/react_authentication";
import useOnboardingPortalStore from '../OnboardingPortal.Store';
import { useTranslation } from "@me8eon/translation";
import { EonUiIcon } from "@eon-ui/eon-ui-components-react";
import { ROLE_ONBOARDING_PORTAL_REVIEWER } from '../OnboardingPortal.constants';

const OnboardingPortalQuickActions = () => {
    const { actualRoles } = useUserData();
    const { setShowModule } = useOnboardingPortalStore();
    const t = useTranslation();
    return (
        <div className="onboarding-portal--side-bar--quick-actions">
            <div className="onboarding-portal--side-bar--quick-actions--title">
                {t("onboardingPortal.quickActions.title")}
            </div>
            <div className="onboarding-portal--side-bar--quick-actions--group">
                <div
                    className="onboarding-portal--side-bar--quick-actions--group--item"
                    onClick={() => setShowModule("onboard-apps")}
                >
                    <EonUiIcon name="add" scheme="red500" />
                    <div>
                        {t("onboardingPortal.quickActions.onboardNewApp")}
                    </div>
                </div>
                <div
                    className="onboarding-portal--side-bar--quick-actions--group--item"
                    onClick={() => setShowModule("manage-apps")}
                >
                    <EonUiIcon name="dashboard_alt_2" scheme="red500" />
                    <div>{t("onboardingPortal.quickActions.manageApps")}</div>
                </div>
                <div
                    className="onboarding-portal--side-bar--quick-actions--group--item"
                    onClick={() => setShowModule("default-apps")}
                >
                    <EonUiIcon name="all_in_one_alt" scheme="red500" />
                    <div>{t("onboardingPortal.quickActions.defaultApps")}</div>
                </div>
            </div>
            <div className="onboarding-portal--side-bar--quick-actions--group">
                <div
                    className="onboarding-portal--side-bar--quick-actions--group--item"
                    onClick={() => setShowModule("onboard-qna")}
                >
                    <EonUiIcon name="add" scheme="red500" />
                    <div>
                        {t("onboardingPortal.quickActions.onboardNewQnA")}
                    </div>
                </div>
                <div
                    className="onboarding-portal--side-bar--quick-actions--group--item"
                    onClick={() => setShowModule("manage-qna")}
                >
                    <EonUiIcon name="dashboard_alt_2" scheme="red500" />
                    <div>{t("onboardingPortal.quickActions.manageQnA")}</div>
                </div>
            </div>
            {actualRoles.includes(ROLE_ONBOARDING_PORTAL_REVIEWER) && (
                <div className="onboarding-portal--side-bar--quick-actions--group">
                    <div
                        className="onboarding-portal--side-bar--quick-actions--group--item"
                        onClick={() => setShowModule("review-dashboard")}
                    >
                        <EonUiIcon name="dashboard" scheme="red500" />
                        <div>
                            {t(
                                "onboardingPortal.quickActions.reviewerDashboard"
                            )}
                        </div>
                    </div>
                    <div
                        className="onboarding-portal--side-bar--quick-actions--group--item"
                        onClick={() => setShowModule("review-apps")}
                    >
                        <EonUiIcon name="value_proposition" scheme="red500" />
                        <div>
                            {t("onboardingPortal.quickActions.reviewApps")}
                        </div>
                    </div>
                    <div
                        className="onboarding-portal--side-bar--quick-actions--group--item"
                        onClick={() => setShowModule("review-qna")}
                    >
                        <EonUiIcon name="value_proposition" scheme="red500" />
                        <div>
                            {t("onboardingPortal.quickActions.reviewQnA")}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OnboardingPortalQuickActions;
